export const content = {
  continue: 'Continue without saving',
  cancel: 'Cancel',
  promptMessage: 'You have unsaved changes, are you sure you want to leave?',
}
